import { useCreateCollectorNoteServiceMutation, useGetNotesByCollectorIdQuery } from "../collector";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import CommonNotesForm from "../../../../components/common/CommonNotesGrid/CommonNotesGrid";
import { useState } from "react";
import NotesUpdateOrAddModal from "../../../../components/common/CommonNotesGrid/NoteAddOrUpdateModal";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const CollectorNotesForm = () => {

    const { collectorId } = useParams();
    const [showAddModal, setShowshowAddModal] = useState(false);
    const [noteBody, setNoteBody] = useState<string>("");
    const [createNotesApi, createNotesApiResp] = useCreateCollectorNoteServiceMutation();
    const {
        data: notesData,
        isLoading: loading,
        isError: error,
    } = useGetNotesByCollectorIdQuery(collectorId || skipToken);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const noteDto = {
            message: noteBody,
            collectorId: collectorId

        };
        if (noteBody) {
            await handleRTKQuery(
                async () => {
                    return await createNotesApi({ id: collectorId, requestBody: noteDto }).unwrap();
                },
                (isSuccess: boolean) => {
                    if (isSuccess) {
                        setShowshowAddModal(false);
                    }
                    setNoteBody("")
                }
            );
        }
    }

    return (
        <>

            <CommonNotesForm
                data={notesData}
                title="Collector Notes"
                type="Collector"
                count={notesData?.length || 0}
                setShow={setShowshowAddModal}
                isLoading={false}
                addPermissions={hasPermission(["COLNOT-C"])}
            />
            {showAddModal &&
                <NotesUpdateOrAddModal title={"Add Collector Notes"}
                    show={showAddModal}
                    setShow={setShowshowAddModal}
                    relationalId={collectorId}
                    type={"Collector"}
                    length={notesData && notesData.length + 1}
                    btnName="Add" setNoteBody={setNoteBody} noteBody={noteBody}
                    handleSubmit={handleSubmit} isLoading={createNotesApiResp.isLoading} />
            }
        </>
    );
};

export default CollectorNotesForm;
